// @flow
import modularui from "../_modularui/ModularUIConnector";
import ListDetailModel from "../../models/list/ListDetailModel";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useListDetail' instead
 */
export const connectListDetail: ModularUIConnector = modularui(
  "ListDetail",
  ({ href }) => href,
  {
    propName: "detail",
    targetModel: ListDetailModel,
  },
);
